import {Link} from "react-router-dom";
import LogoDark from "../../images/logo-dark.png"
import {useCallback, useEffect, useState} from "react";
import {register} from "../../store/actions/auth";
import {useDispatch, useSelector} from "react-redux";

const Register = () => {
    const { error } = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleRegister = () => {
        if (username === "" || email === "" || password === "") {
            return;
        }

        dispatch(register(username, email, password));
    }

    return (
        <div className="wrapper">
            <div className="wrapper-inner">

                <div className="content clearfix">

                    <div className="section-block replicable-content window-height bkg-heavy-rain-gradient">
                        <div className="row flex v-align-middle">
                            <div className="column width-6 offset-3">
                                <div>
                                    <div className="logo mb-50">
                                        <div className="logo-inner center">
                                            <Link to="/"><img src={LogoDark} width="125" alt="흑우촌 로고"/></Link>
                                        </div>
                                    </div>
                                    <div className="signup-box box rounded xlarge bkg-white shadow">
                                        <p className="mb-20 center">이미 회원이신가요? <Link
                                            to="/login" className="fade-location">로그인</Link></p>
                                        <div className="register-form-container">
                                            <div className="row">
                                                <div className="column width-12">
                                                    <div className="field-wrapper">
                                                        <label className="color-charcoal">아이디:</label>
                                                        <input type="text"
                                                               onChange={(e) => setUsername(e.target.value)}
                                                               className="form-username form-element rounded medium"
                                                               placeholder="아이디 (6~20자 영문 소문자 또는 숫자)" required />
                                                    </div>
                                                </div>
                                                <div className="column width-12">
                                                    <div className="field-wrapper">
                                                        <label className="color-charcoal">이메일:</label>
                                                        <input type="email"
                                                               onChange={(e) => setEmail(e.target.value)}
                                                               className="form-email form-element rounded medium"
                                                               placeholder="johndoe@gmail.com" required />
                                                    </div>
                                                </div>
                                                <div className="column width-12">
                                                    <div className="field-wrapper">
                                                        <label className="color-charcoal">비밀번호:</label>
                                                        <input type="password"
                                                               onChange={(e) => setPassword(e.target.value)}
                                                               className="form-password form-element rounded medium"
                                                               placeholder="•••••••• (8~16자 영문, 숫자, 특수문자)"
                                                               required />
                                                    </div>
                                                </div>
                                                <div className="column width-12">
                                                    <div className="field-wrapper pt-0 pb-20">
                                                        <input id="checkbox-1"
                                                               className="form-element checkbox rounded"
                                                               name="login[checkbox-1]" type="checkbox" required />
                                                        <label htmlFor="checkbox-1"
                                                               className="checkbox-label no-margins"><Link to="/tos" target="_blank">흑우촌 이용약관</Link> 동의</label>
                                                    </div>
                                                </div>
                                                {
                                                    error &&
                                                    <div className="column width-12">
                                                        <div className="field-wrapper pt-0 pb-20">
                                                            <div className="box rounded small warning">
                                                                {error}
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                <div className="column width-12 mt-10 center">
                                                    <input type="submit" value="회원가입" onClick={handleRegister}
                                                           className="form-submit button rounded medium bkg-green bkg-hover-theme bkg-focus-green color-white color-hover-white no-margins" />
                                                </div>
                                            </div>
                                            <div className="form-response show"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default Register;